<template>
  <div>
    <el-upload
      ref='upload'
      class='upload-demo'
      :disabled='uploadDis'
      :action='importUrl'
      :auto-upload='true'
      :show-file-list='false'
      :data='uploadData'
      :http-request='uploadHttp'
      :on-success='planOnSuccess'
      :before-upload='beforeUpload'
    >
      <i class='el-icon-upload el-icon--right'>导入对账单</i>
    </el-upload>
    <el-dialog
      title='提示'
      :visible.sync='dialogVisible'
      width='400px'
      top='35vh'
      :close-on-click-modal='false'>
      <div style='max-height: 40vh;text-align: left;' v-html='message'></div>
      <div slot='footer' class='dialog-footer'>
        <el-button class='cancel-button' type='primary' size='mini' @click='dialogClose'>
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getImport, getImportUrl } from '@/service/getIP';

  export default {
    name: 'import-statement',
    props: {
      type: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        dialogVisible: false,
        message: '',
        uploadDis: false,
        importUrl: '',
        uploadData: { mFile: '' },
      };
    },
    mounted() {
      this.importUrl = getImportUrl('/customer/account/importRSIExcel');
    },
    methods: {
      // 批量导入
      planOnSuccess(res) {
        this.uploadDis = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        // this.$parent.importStatement();
      },
      beforeUpload(file) {
        this.uploadDis = true;
        const len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.mFile = file.name;
        } else {
          this.uploadDis = false;
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      dialogClose() {
        this.dialogVisible = false;
        // this.message = '';
        this.$emit('getList');
      },
      uploadHttp(content) {
        let formData = new FormData();
        formData.append('file', content.file, content.file.name);
        let that = this;
        this.$emit('changeImportLoading', true);
        this.$axios({
          method: 'post',
          url: content.action + '&type=' + this.type,
          timeout: 600 * 1000,
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        })
          .then(res => {
            this.uploadDis = false;
            this.$emit('changeImportLoading', false);
            this.message = res.data.message;
            this.dialogVisible = true;
          })
          .catch(error => {
            if (error.response) {
              that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
              console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            } else if (error.request) {
              that.$message.error('配时文件上传失败，服务器端无响应');
              console.log('配时文件上传失败，服务器端无响应');
            } else {
              that.$message.error('配时文件上传失败，请求封装失败');
              console.log('配时文件上传失败，请求封装失败');
            }
            this.uploadDis = false;
          });
      },
    },
  };
</script>

<style lang='scss' scoped>
  ::v-deep {
    .el-dialog__body {
      max-height: 40vh;
      overflow: auto;
    }

    .cancel-button span {
      color: #fff !important;
    }
  }
</style>
